import React from 'react';

/**
 * Used to store Budget Suggestions context
 */
export const BudgetSuggestionsContext = React.createContext({
  limitedByBudgetCampaignIds: [],
  setLimitedByBudgetCampaignIds: () => { },
  hideLimitedStatus: () => { },
  setHideLimitedStatus: () => { },
});
